import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'core-profile',
  templateUrl: './profile.component.html'
})
export class ProfileComponent implements OnInit {
  user = {};
  form = new FormGroup({});
  fields: FormlyFieldConfig[] = [
    {
      key: 'FirstName',
      type: 'input',
      templateOptions: {
        type: 'text',
        label: 'First Name',
        placeholder: 'Enter first name',
        required: true
      }
    },
    {
      key: 'LastName',
      type: 'input',
      templateOptions: {
        type: 'text',
        label: 'Last Name',
        placeholder: 'Enter last name',
        required: true
      }
    },
    {
      key: 'Username',
      type: 'input',
      templateOptions: {
        disabled: true,
        type: 'text',
        label: 'Username',
        placeholder: 'Enter username',
        required: true
      }
    },
    {
      key: 'Email',
      type: 'input',
      templateOptions: {
        type: 'email',
        label: 'Email address',
        placeholder: 'Enter email',
        required: true
      }
    },
    {
      key: 'Phone',
      type: 'input',
      templateOptions: {
        type: 'text',
        label: 'Phone',
        placeholder: 'Enter phone',
        required: true
      }
    }
  ];


  constructor(public activeModal: NgbActiveModal, private authService: AuthService,
              private router: Router, private toastr: ToastrService) {
  }

  ngOnInit() {
    this.authService.getUserInfo()['toPromise']().then((data) => {
      this.user = data;
    });
  }


  updateProfile() {
    if (this.form.valid) {
      console.log(this.user);
    }
  }

}
